import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const ReveenLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch('/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          password,
          adminuserid: window.APPSETTING.adminuserid,
          appname: window.APPSETTING.appname
        }),
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || data.error || 'Login failed');
      }

      window.APPUSER = data;
      localStorage.setItem(window.APPSETTING.appname + "user", JSON.stringify(data));
      if (data.user?.usertype === 'admin') {
        navigate('/dashboard');
      } else {
        navigate('/subscriptions');
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <div className="page-card" style={{ maxWidth: '400px', margin: '3rem auto' }}>
      <div className="eyebrow">WELCOME BACK</div>
      <h2 style={{ fontFamily: 'var(--display)', fontSize: '1.9rem', fontWeight: 800, letterSpacing: '-0.03em', margin: '0 0 20px' }}>Reveen Login</h2>
      {error && <div style={{ color: 'var(--danger)', fontSize: '0.8rem', margin: '0 0 14px' }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="fg">
          <label style={{ color: 'var(--cust-muted)' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="btn-blue" style={{ width: '100%' }}>Login</button>
      </form>
      <div style={{ marginTop: '1.25rem', fontSize: '0.85rem', textAlign: 'center', color: 'var(--cust-muted)' }}>
        Don't have an account? <Link to="/signup" style={{ textDecoration: 'underline' }}>Signup</Link>
      </div>
    </div>
  );
};

export default ReveenLogin;